const ApiProfile = ravenApiLevel => {
    if(!ravenApiLevel) {
        return RavenApiBase();
    }
    // Add new Api Levels here
    if(ravenApiLevel >= 13) {
        return RavenApi13();
    }
    if(ravenApiLevel >= 12) {
        return RavenApi12();
    }
    return RavenApiBase();
};

const RavenApiBase = () => ({
    videoPreviewRequest: false,
    userMediaRequest: false
});

const RavenApi12 = () => Object.assign(RavenApiBase(), {
    videoPreviewRequest: true,
    userMediaRequest: false
});

const RavenApi13 = () => Object.assign(RavenApiBase(), {
    videoPreviewRequest: true,
    userMediaRequest: true
});

export default ApiProfile;
